import {createContext, useState } from 'react'

export const langContext = createContext("en");

